import React from 'react'
import RecruiterRegistraionComponent from '../Components/RecruiterRegistraionComponent'

function RecruiterRegistrationPage() {
  return (
    <div>
        <RecruiterRegistraionComponent />
    </div>
  )
}

export default RecruiterRegistrationPage